import HeroCarousel from './components/hero-carousel';
import createHowItWorksCarousel from './components/hiw-carousel';
import createScrollableElements, { centerAlignScrollableElement, scrollOnHover } from './components/scrollable';
import createProductFeatures from './components/product-features';
import Accordion from './components/Accordion';
import UserBehaviourTracking from './utils/UserBehaviourTracking';
import ScrollToElement from './components/ScrollToElement';
import { trackEvent } from 'common/utils/analytics';

// Hero scroll to HIW link
document.addEventListener('DOMContentLoaded', () => {
    for (const link of document.querySelectorAll('[data-hero-scrollto-link]')) {
        new ScrollToElement(link).handleClick();
    }
});

document.addEventListener('DOMContentLoaded', () => {

    // Track FAQ usage to Segment
    for (const faq of document.querySelectorAll('#faqs [data-accordion-item-trigger]')) {
        faq.addEventListener('click', (e) => trackEvent('Clicked FAQ on Product Page', {
            title: faq.textContent.trim(),
        }));
    }

    // Product features
    createProductFeatures();

    // How it works
    createHowItWorksCarousel(document.querySelector('[data-hiw]'));

    // horizontally scrollable elements
    createScrollableElements();

    // Example designs
    scrollOnHover('[data-scrollable="examples"]');
    centerAlignScrollableElement('[data-scrollable="examples"]')
        .then((el) => {
            for (let card of document.querySelectorAll('[data-design-card]')) {
                card.style.visibility = 'visible';
            }
        });

    // Contest listings
    scrollOnHover('[data-scrollable="contests"]');
    centerAlignScrollableElement('[data-scrollable="contests"]');

    // Hero carousel
    HeroCarousel.create().start();

    // FAQs
    Accordion.create();

    if (window.pageCategoryKey === 'logo-design') {
        window.userBehaviourTracking = new UserBehaviourTracking();
    }
});



// WEBPACK FOOTER //
// ./js/marketing/product.js